import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CardsSection from '@/pages/home/components/CardsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import IndexSection from '@/pages/home/components/IndexSection';
import MediaSection from '@/pages/home/components/MediaSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <FeaturesSection />
        <CarouselSection />
        <CardsSection />
        <ContactSection />
        <FaqSection />
        <AboutSection />
        <AppSection />
        <IndexSection />
        <MediaSection />
        <TopicsSection />
        <CommentsSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}